<app-page padding="0">
  <div class="h-full p-0" >
    <div class="row flex">
      <div class="col-4">
        <app-card title="Codice Istat">
         <app-input-select-string
          (datiCercati)="checkContentComune($event)"
          title="nome" 
          [form]="insertForm"
          name="comune"
          [allData]="comuni!"
          [canAdd]="false"
          placeholder="Cerca Comuni..."
          >
        </app-input-select-string> 
        <app-button  [disabled]="!isDisableMostraMappa" label="Mostra sulla Mappa" icon="add" (click)="mostraComuneMappa()" raised  cdkFocusRegionstart></app-button>
        </app-card>
        <br>
        <app-card title="Aree SubComunali">
          <app-input-select-string
          (datiCercati)="checkContent($event)"
          (removeDati)="deleteFeature($event)"
          title="denAsc1" 
          [form]="insertForm"
          [istatComune]="istatComune"
          [isDisabled]="isDisabledAllInput"
          name="areaSubComunale"
          [allData]="areaSubComunale!"
          [canAdd]="false"
          placeholder="Cerca AreaSubComunale..."
          >
        </app-input-select-string> 
        </app-card>
        <br>
        <app-card title="Località">
          <app-input-select-string
          (datiCercati)="checkContent($event)"
          (removeDati)="deleteFeature($event)"
          title="nome" 
          [form]="insertForm"
          [istatComune]="istatComune"
          [isDisabled]="isDisabledAllInput"
          name="localita"
          [allData]="localita!"
          [canAdd]="false"
          placeholder="Cerca Località..."
          >
        </app-input-select-string> 
        </app-card>
        <br>
        <app-card title="Zona Censuaria">
          <app-input-select-string
          (datiCercati)="checkContent($event)"
          (removeDati)="deleteFeature($event)"
          title="sez21Id" 
          [form]="insertForm"
          [istatComune]="istatComune"
          [isDisabled]="isDisabledAllInput"
          name="zonaCensuaria"
          [allData]="zonaCensuaria!"
          [canAdd]="false"
          placeholder="Cerca Zona Censuaria..."
          >
        </app-input-select-string> 
        </app-card>
        <br>
      </div>
      <div class="col-8">
        <app-card title="Metadati">
          <app-input-text [form]="insertForm" name="nome" label="nome"></app-input-text>
        </app-card>
        <google-map 
        height="500px" 
        width="100%" 
        [center]="center" 
        [zoom]="zoom" 
        [options]="options">
      </google-map>
      </div>
    </div>  
  </div>
  <div footer class="text-center"  *ngIf="showData">
    <div>
      <div class="p-2 flex flex-end w-full" style="justify-content: end;">
        <app-button *ngIf="createPermission" (click)="onSendWszGeojsonClick()" [disabled]="!insertForm.valid"  [fullWidth]="false"  icon="send" label="Salva" raised/>
      </div>
    </div>
  </div>
</app-page>
